export default "__VITE_ASSET__il8QB2ot__"